import React from 'react'
import AddWorkspace from '../views/shared/settings/slack/AddWorkspace';
import { useQueryClient } from '@tanstack/react-query';
import useModal from './modalHook';

const useSlack = () => {
    const invalidatequery = useQueryClient();
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const SlackModal = ModalComponent;

        const showAddWorkspaceModal = () => {
            updateModalStates({
                show: true,
                size: 'lg',
                children: (
                    <AddWorkspace
                        onProceed={() => {
                            invalidatequery.invalidateQueries({ queryKey: ['workspaces'] });
                            closeModal();
                        }}
                        onClose={closeModal}
                    />
                ),
                classes: '!p-0 r-[5px]',
                showCloseButton: false
            });
        }
        
  return {
    SlackModal,
    showAddWorkspaceModal
  }
}

export default useSlack;